<template>
    <section class="favorite">
        <!--工具条-->
        <FullCalendar :locale="locale"
                      :first-day="1"
                      ref="fullCalendar"
                      defaultView="timeGridWeek"
                      :plugins="calendarPlugins"
                      :now-indicator="true"
                      :all-day-slot="false"
                      min-time="00:00:00"
                      max-time="24:00:00"
                      slot-duration="00:30:00"
                      slot-label-interval="01:00:00"
                      height='100%'
                      :content-height="content_height"
                      :nav-links="true"
                      event-class-name="course-inner-text"
                      :events="loadEvents"
                      :event-time-format="eventTimeFormat"
                      :slot-label-format="slotLabelFormat"
                      @eventClick="handleEventClick"
                      :custom-buttons="customButtons"
                      :selectable="true"
                      :select-overlap="false"
                      :select-allow="allow"
                      @select="handleSelect"
                      @windowResize="handleResize"
                      scroll-time="08:00"

                      :header="{center:'title', left:'newMeeting,goList,today,prev,next ',
                      right:'timeGridDay,timeGridWeek,dayGridMonth,listWeek'}"
        />
        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees"
                      btn_modify btn_delete btn_poll @poll="handlePoll"
                      @cancel="view_mode = false" @delete="handleDelete">
        </meeting-view>


    </section>

</template>

<script>
    import CalendarMixins from "../common/mixins/calendar-mixin";
    import MeetingView from "../components/meeting-view";

    export default {
        name: "calendar",
        mixins:[CalendarMixins],
        components:{MeetingView},
        data() {
            return {
                poll_view:false,
                polls:{},
                content_height:100,
                screen_height:100,
            }
        },
        mounted() {
            this.screen_height =  document.body.clientHeight;
            this.content_height = this.screen_height - 200;
        },
        methods:{
            handleResize(arg){
                this.screen_height =  document.body.clientHeight;
                this.content_height = this.screen_height - 200;
                arg.updateSize();
            }
        },
    }
</script>

<style lang="scss">
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
    @import "~@fullcalendar/list/main.css";

    .fc-icon.fc-icon-el-icon {
        font-family: 'element-icons',serif !important;
    }

    .favorite {
        .course-inner-text {
            color: white;
            font-size: 14px;
            background-color: #009688;
            transition: all 0.4s ease;

            .fc-time {
                color: white;
                font-size: 13px;
                font-weight: bold;
            }

            &:hover {
                color: whitesmoke;
                cursor: pointer;
                background-color: #0288d1;
                border-color: #0288d1;
                box-shadow: 1px 1px 9px rgba(0, 0, 0, 0.5);
                transition: all 0.4s ease;

            }

            &.fc-list-item {
                background-color: transparent;
                color: black;

                &:hover {
                    box-shadow: none;
                }
            }
        }


    }

</style>
